import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, roles }) => {
    const token = localStorage.getItem('token');
    const userRoles = JSON.parse(localStorage.getItem('roles'));
    console.log(userRoles)
    console.log(token)

    if (!token) {
        return <Navigate to="/login" />;
    }

    if ( userRoles.includes('ADMIN')) {
        return children;
    }

    return children;
};

export default ProtectedRoute;